import { useCreateCashTransaction } from 'api-hooks/transactions/cash-transaction';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import { NavigationProps } from 'types';

import CashTransactionForm from './components/form';

export type CashTransactionsCreateParams = null;

export default function CashTransactionsCreate(
  props: NavigationProps<NavigationRoutes.CashTransactionsCreate>,
) {
  const { mutateAsync, error } = useCreateCashTransaction();

  const onResolve = useApprovalableEdit('cash-transactions');

  return (
    <>
      {!!error && !!error.message && (
        <>
          <Notification
            overrides={{
              Body: { style: { width: 'auto', wordBreak: 'break-all' } },
            }}
            kind={KIND.negative}
            closeable
          >
            {() => error.message}
          </Notification>
        </>
      )}
      <CashTransactionForm
        {...props}
        onSubmit={async (input, form) => {
          const result = await mutateAsync(input);
          onResolve(result);
          return result.data;
        }}
      />
    </>
  );
}
